/*
 * Helper function to convert MongoDB Point to GoogleMaps LatLng
 */
export default function formatLocation(location) {
    if (!location) {
        return null;
    }
    if (!location.hasOwnProperty('coordinates')) {
        return null;
    }
    if (!Array.isArray(location.coordinates)) {
        return null;
    }
    if (location.coordinates.length !== 2) {
        return null;
    }
    return {
        lat: location.coordinates[1],
        lng: location.coordinates[0],
    }
}
